// Messages for operator/marketing/EditorTabs (auto-merged by lib/i18n.ts).
export const en = {
  'operator.marketing.editor.unpublished': 'Unpublished changes',
}

export const zhTW = {
  'operator.marketing.editor.unpublished': '有未發布的變更',
}
